import React from "react";
import { Table } from "reactstrap";

const VehiclesTab = ({ assets = [] }) => {
    if (assets.length === 0) {
        return <p className="text-center text-muted py-4">No vehicles recorded.</p>;
    }

    return (
        <Table responsive hover bordered className="table-sm">
            <thead style={{ backgroundColor: "#0147C8", color: "white" }}>
            <tr>
                <th style={{ width: "50px" }}>#</th>
                <th>Reg & Chassis No.</th>
                <th>Make / Model</th>
                <th>Specs (Fuel/Engine)</th>
                <th>Origin & Manufacture</th>
                <th>Location</th>
                <th>Condition</th>
            </tr>
            </thead>
            <tbody>
            {assets.map((a) => {
                const condition = a.observed_condition_name || a.observed_condition || "N/A";

                // Concatenating physical location fields from your schema
                const locationDetails = [
                    a.building_name,
                    a.floor,
                    a.room_name_or_number
                ].filter(Boolean).join(", ") || "-";

                return (
                    <tr key={a.id}>
                        <td className="fw-bold text-muted">{a.serialNumber || "-"}</td>
                        {/* registration_number and chassis_number */}
                        <td>
                            <div className="fw-bold text-primary">{a.registration_number || "-"}</div>
                            <small className="text-muted">Chassis: {a.chassis_number || "N/A"}</small>
                        </td>
                        {/* make and model */}
                        <td>
                            <strong>{a.make} {a.model}</strong>
                            <div className="small text-muted">{a.name}</div>
                        </td>
                        {/* fuel_type and engine_capacity */}
                        <td>
                            <div className="fw-medium">{a.fuel_type || "-"}</div>
                            <small className="text-muted">{a.engine_capacity ? `${a.engine_capacity} cc` : "N/A"}</small>
                        </td>
                        {/* imported_from and year_of_manufacture */}
                        <td>
                            <div>{a.imported_from || "Local"}</div>
                            <small className="text-muted">Year: {a.year_of_manufacture || "-"}</small>
                        </td>
                        {/* institution_name and location logic */}
                        <td>
                            <div className="small fw-medium">{a.institution_name || "-"}</div>
                            <small className="text-muted">{locationDetails}</small>
                        </td>
                        <td>
                            {condition}
                        </td>
                    </tr>
                );
            })}
            </tbody>
        </Table>
    );
};

export default VehiclesTab;